define('environments/preproduction',{
  env: "preproduction",
  defaultDomain: "https://signup.pre.mdirector.com/",
  backendUrl: "https://signup-backend.pre.mdirector.com",
  mdirectorUrl: "https://app.pre.mdirector.com",
  mdirectorPrivateUrl:
    "https://app.pre.mdirector.com/private?redirect=dashboard",
  landingsUrl: "https://landings.pre.mdirector.com",
  transUrl: "https://trans.pre.mdirector.com",
  automationUrl: "https://automation.pre.mdirector.com",
  authUrl: "https://auth.pre.mdirector.com",
  paymentsUrl: "https://payments.pre.mdirector.com/",
  captchaPublicKey: "6LeP380UAAAAANdkQPCqAs8UGGhwoti0x7Pjg8Mc",
  i18nCookieDomain: ".pre.mdirector.com",
  getProvincesUrl:
    "https://signup-backend.pre.mdirector.com/provinces/country/",
  getCountriesUrl: "https://signup-backend.pre.mdirector.com/countries",
  getUserDataUrl: "https://signup-backend.pre.mdirector.com/signup/",
  postUserServicesUrl: "https://signup-backend.pre.mdirector.com/user-services",
  submitUrl: "https://signup-backend.pre.mdirector.com/signup",
  secondStepRedir: "/activation",
  themeAssetsUrl: "https://static.pre.mdirector.com/assets/themes/",
  myAccountUrl: "https://signup.pre.mdirector.com/accounts",
  showBalanceArray: [],
  registerUrl: {
    es: "https://www.pre.mdirector.com/signup/",
    fr: "https://www.pre.mdirector.com/fr/signup/",
    it: "https://www.pre.mdirector.com/it/signup/",
    pt: "https://www.pre.mdirector.com/pt/signup/",
    en: "https://www.pre.mdirector.com/en/signup/",
  },
  ga: {
    ua: "UA-46499122-1",
    tagmanagerId: "GTM-WX6H3W",
    domain: "mdirector.com",
  },
  trackingFirstStepDefaultParams: {
    origin: "web",
    service: "mdirector",
    productId: "emailmarketing",
    productName: "Email Marketing",
    landingName: "No_LANDING_Direct_Registry",
  },
  securityOptionsAllowGroups: [],
  SECURE_PASSWORD_LENGTH: 8,
  maintenanceUrl: "https://static.pre.mdirector.com/assets/js/maintenance.js",
  CPSAgreements: {
    cookieDismissName: "CPSAgreementsDismiss",
    cookieDismissValue: "ok",
    cookieDismissExpirationDays: 1,
    externalTermsURL: {
      es: "https://pmp.antevenio.com/mdirector/cps-mdirector-esp-es",
      en: "https://pmp.antevenio.com/mdirector/cps-mdirector-eng-es",
      it: "https://pmp.antevenio.com/mdirector-it/md-cps-it",
    },
    canBeDelayed: false,
  },
  integrations: {
    zapierEnabled: true,
    shopifyEnabled: true,
    APIsEnabled: true,
  },
});

